import React from 'react'
import { Icon, Tooltip, Text } from '@components/UI'
import { Sketch as SK } from '@constants'

const Palette = ({ color, onClick, dark, tooltip = {} }) => {
  return (
    <div className={`control-container ${dark ? 'dark' : ''}`}>
      {color.fill === '(0,0,0)' && color.border === '(0,0,0)' ? (
        <button>
          <Icon name='colors' />
        </button>
      ) : (
        <button>
          <div
            style={{
              backgroundColor:
                color.fill === '(0,0,0)'
                  ? 'rgba(255, 255, 255, .15)'
                  : `rgba(${color.fill.slice(1, -1)}, 1)`,
              width: '12px',
              height: '12px',
              borderRadius: '6px',
              position: 'absolute',
              top: 7,
              right: 7,
              zIndex: 2
            }}
          />
          <div
            style={{
              backgroundColor: 'transparent',
              border: `1px solid ${
                color.border === '(0,0,0)'
                  ? 'rgba(255, 255, 255, .15)'
                  : `rgba(${color.border.slice(1, -1)}, 1`
              }`,
              width: '12px',
              height: '12px',
              borderRadius: '6px',
              boxSizing: 'border-box',
              bottom: 7,
              left: 7,
              position: 'absolute',
              zIndex: 1
            }}
          />
        </button>
      )}

      <Tooltip
        content={
          <div className='tooltip-content'>
            <div>
              <Text
                className='text-c semibold'
                style={{ lineHeight: 1, opacity: 0.5 }}
              >
                Line Color
              </Text>
              <div style={{ display: 'flex', marginTop: 8 }}>
                {SK.COLOR_PALETTE.map((v, i) => (
                  <div
                    className={`circle outline ${
                      v === color.border ? 'active' : ''
                    }`}
                    style={{ borderColor: `rgba(${v.slice(1, -1)}, 1)` }}
                    key={`circle-outline-${i}`}
                    onClick={() =>
                      onClick({ border: color.border === v ? '(0,0,0)' : v })
                    }
                  />
                ))}
              </div>
            </div>
            <div style={{ marginTop: 16 }}>
              <Text
                className='text-c semibold'
                style={{ lineHeight: 1, opacity: 0.5 }}
              >
                Fill Color
              </Text>
              <div style={{ display: 'flex', marginTop: 8 }}>
                {SK.COLOR_PALETTE.map((v, i) => (
                  <div
                    className={`circle ${v === color.fill ? 'active' : ''}`}
                    style={{ backgroundColor: `rgba(${v.slice(1, -1)}, 1)` }}
                    key={`circle-${i}`}
                    onClick={() =>
                      onClick({ fill: color.fill === v ? '(0,0,0)' : v })
                    }
                  />
                ))}
              </div>
            </div>
          </div>
        }
        group={tooltip.top ? 'c2' : 'c7'}
        className='theme color-f background-a border'
      />
      <Icon name='arrow down' />
    </div>
  )
}

export default Palette
